export default `
.dte-sheet--standard,
.dte-sheet--standard * {
  font-family: Arial, sans-serif;
}

.dte-sheet--standard {
  padding: 0.28in 0.42in 0.34in;
  border-radius: 0;
  box-shadow: none;
  color: #000000;
}

.dte-sheet--standard .dte-sheet__page-number {
  left: 0;
  right: auto;
  bottom: 0.08in;
  color: #000000;
  font-size: 9px;
}

.dte-sheet--standard .dte-standard-gap {
  height: 10px;
}

.dte-sheet--standard .dte-standard-badges {
  display: grid;
  gap: 6px;
  margin-bottom: 10px;
}

.dte-sheet--standard .dte-standard-alert {
  padding: 6px 10px;
  background: #cc0000;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
}

.dte-sheet--standard .dte-standard-header {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 10px;
  align-items: start;
}

.dte-sheet--standard .dte-standard-issuer {
  font-size: var(--dte-text-font-size);
  line-height: 1.14;
}

.dte-sheet--standard .dte-standard-issuer__logo {
  margin-bottom: 6px;
}

.dte-sheet--standard .dte-standard-logo {
  display: block;
  max-width: 330px;
  max-height: 100px;
  width: auto;
  height: auto;
}

.dte-sheet--standard .dte-standard-issuer__line {
  margin-bottom: 3px;
}

.dte-sheet--standard .dte-standard-issuer__line--business {
  font-size: calc(var(--dte-title-font-size) - 1px);
  font-weight: 700;
}

.dte-sheet--standard .dte-standard-issuer__text--pre {
  white-space: pre-line;
}

.dte-sheet--standard .dte-standard-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--dte-text-font-size);
}

.dte-sheet--standard .dte-standard-table--boxed {
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid var(--dte-table-border, #000000);
  border-radius: var(--dte-table-radius, 0px);
  overflow: hidden;
}

.dte-sheet--standard .dte-standard-table--meta td,
.dte-sheet--standard .dte-standard-table--boxed td,
.dte-sheet--standard .dte-standard-table--boxed th {
  border-left: 1px solid var(--dte-table-border, #000000);
  border-right: 1px solid var(--dte-table-border, #000000);
}

.dte-sheet--standard .dte-standard-table--boxed tr > td:first-child,
.dte-sheet--standard .dte-standard-table--boxed tr > th:first-child {
  border-left: none;
}

.dte-sheet--standard .dte-standard-table--boxed tr > td:last-child,
.dte-sheet--standard .dte-standard-table--boxed tr > th:last-child {
  border-right: none;
}

.dte-sheet--standard .dte-standard-table--meta td {
  border-left: none;
  border-right: none;
}

.dte-sheet--standard .dte-standard-table__title-cell {
  padding: 5px 10px;
  text-align: center;
  font-weight: 700;
  font-size: calc(var(--dte-title-font-size) - 2px);
}

.dte-sheet--standard .dte-standard-table__label {
  font-weight: 700;
}

.dte-sheet--standard .dte-standard-table__label--inline {
  white-space: nowrap;
}

.dte-sheet--standard .dte-standard-table--meta td {
  padding: 4px 9px;
  vertical-align: top;
  line-height: 1.1;
}

.dte-sheet--standard .dte-standard-table__qr {
  padding: 6px 10px !important;
  text-align: center;
}

.dte-sheet--standard .dte-standard-qr {
  width: 108px;
  height: 108px;
  object-fit: contain;
}

.dte-sheet--standard .dte-standard-qr--placeholder {
  display: inline-block;
  border: 1px dashed rgba(0, 0, 0, 0.35);
  background: rgba(0, 0, 0, 0.03);
}

.dte-sheet--standard .dte-standard-table--document-extra {
  margin-top: 4px;
}

.dte-sheet--standard .dte-standard-table--document-extra td {
  padding: 3px 9px 0;
}

.dte-sheet--standard .dte-standard-banner {
  margin-top: 10px;
}

.dte-sheet--standard .dte-standard-banner__image {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: contain;
}

.dte-sheet--standard .dte-standard-table--recipient td {
  padding: 3px 8px;
  vertical-align: top;
  line-height: 1.1;
}

.dte-sheet--standard .dte-standard-table__multiline {
  white-space: pre-line;
  overflow-wrap: anywhere;
  word-break: normal;
}

.dte-sheet--standard .dte-standard-table__header-row th {
  padding: 3px 4px;
  border: 1px solid var(--dte-table-border, #000000);
  text-align: left;
  font-weight: 700;
  font-size: calc(var(--dte-detail-font-size) - 1px);
  line-height: 1.05;
}

.dte-sheet--standard .dte-standard-table__header-cell--small {
  width: 38px;
}

.dte-sheet--standard .dte-standard-table__header-cell--amount {
  width: 72px;
}

.dte-sheet--standard .dte-standard-table__body-cell,
.dte-sheet--standard .dte-standard-table--detail td {
  padding: 4px;
  border-left: 1px solid var(--dte-table-border, #000000);
  border-right: 1px solid var(--dte-table-border, #000000);
  vertical-align: top;
  font-size: var(--dte-detail-font-size);
  line-height: 1.08;
}

.dte-sheet--standard .dte-standard-table__detail-row:last-child td {
  border-bottom: 1px solid var(--dte-table-border, #000000);
}

.dte-sheet--standard .dte-standard-table__tail-cell {
  padding: 6px 8px;
  vertical-align: top;
  border-top: 1px solid var(--dte-table-border, #000000);
  border-left: 1px solid var(--dte-table-border, #000000);
  border-right: 1px solid var(--dte-table-border, #000000);
}

.dte-sheet--standard .dte-standard-table__tail-cell--words {
  white-space: pre-line;
  line-height: 1.18;
}

.dte-sheet--standard .dte-standard-table__tail-cell--totals {
  padding-top: 4px;
  padding-bottom: 4px;
}

.dte-sheet--standard .dte-standard-table__tail-cell--notes {
  white-space: pre-line;
  line-height: 1.15;
}

.dte-sheet--standard .dte-standard-table__right {
  text-align: right;
}

.dte-sheet--standard .dte-standard-table__center {
  text-align: center;
}

.dte-sheet--standard .dte-standard-table__empty {
  padding: 6px;
  text-align: center;
  border-bottom: 1px solid var(--dte-table-border, #000000);
}

.dte-sheet--standard .dte-standard-totals-table {
  width: auto;
  margin-left: auto;
  border-collapse: collapse;
  font-size: var(--dte-text-font-size);
}

.dte-sheet--standard .dte-standard-totals-table td {
  padding: 2px 0;
  border: none;
}

.dte-sheet--standard .dte-standard-totals-table td:first-child {
  text-align: right;
  padding-right: 8px;
}

.dte-sheet--standard .dte-standard-totals-table__amount {
  width: 106px;
  padding-left: 8px !important;
}

.dte-sheet--standard .dte-standard-totals-table__amount,
.dte-sheet--standard .dte-standard-totals-table__value-inline {
  white-space: nowrap;
}

.dte-sheet--standard .dte-standard-totals-table__amount {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.dte-sheet--standard .dte-standard-totals-table__currency-inline {
  flex: 0 0 auto;
  text-align: left;
}

.dte-sheet--standard .dte-standard-totals-table__value-inline {
  flex: 1 1 auto;
  text-align: right;
}

.dte-sheet--standard .dte-standard-totals-table tr.is-emphasis td {
  font-size: 10.5px;
  font-weight: 700;
}

.dte-sheet--standard .dte-standard-closing__notes {
  border-top: 1px solid #000000;
  white-space: pre-line;
}

.dte-sheet--standard .dte-standard-footer {
  border: 1px solid #000000;
  padding: 6px 0;
}

.dte-sheet--standard .dte-standard-table--responsibles td {
  padding: 4px 8px;
  vertical-align: top;
  line-height: 1.1;
  font-size: var(--dte-text-font-size);
}

@media print {
  .dte-sheet--standard {
    box-shadow: none !important;
    border-radius: 0 !important;
  }
}
`;
